'use strict';

angular.module('DoohApps').factory('MediaAssetsFile', ['restApi', 'DoohConfig', 'Constants', function (restApi, DoohConfig, Constants) {
    var controllerName = 'MediaAssets/';

    return {
        getVideoInformation: function (successCallback, videoUrl) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetVideoInformation?videoUrl=' + encodeURIComponent(videoUrl));
        },
        getMediaAssetsFileByIds: function (successCallback, Id) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetMediaFileByIds?Id=' + Id);
        }
    }
}]).factory('NewMediaAssetFile', function () {
    //New Media Asset File/////

    var MediaAsset = {};
    MediaAsset.AddFile = {};
    MediaAsset.AddFile.IsArchived = false;
    MediaAsset.AddFile.IsPublic = true;
    MediaAsset.AddFile.LanguageID = 1;
    MediaAsset.AddFile.MediaAssetID = 0;
    MediaAsset.AddFile.FileDuration = '0 Minutes';
    MediaAsset.AddFile.HasFile = false;
    MediaAsset.AddFile.TagList = [];

    MediaAsset.Clear = function () {

        MediaAsset.AddFile = {};
        MediaAsset.AddFile.IsArchived = false;
        MediaAsset.AddFile.IsPublic = true;
        MediaAsset.AddFile.LanguageID = 1;
        MediaAsset.AddFile.MediaAssetID = 0;
        MediaAsset.AddFile.FileDuration = '0 Minutes';
        MediaAsset.AddFile.HasFile = false;
        MediaAsset.AddFile.TagList = [];
    }

    return MediaAsset;
});
